import { render } from "./kalio-add-office-hours.vue?vue&type=template&id=3d6e3604"
import script from "./kalio-add-office-hours.vue?vue&type=script&lang=js"
export * from "./kalio-add-office-hours.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__